<template>
  <div ref="container">
    <tip-tap
      v-model="commentText"
      :readonly="readOnly || printView"
      :label="printView ? $t('notAvailable') : $t('comment')"
      :hint="hint"
      @blur="leaveField"
      @focus="enterField"
    />
  </div>
</template>

<script>
import { feedbackEnums } from '@/enums/feedbacks.js';
import TipTap from '@/components/editor/TipTap.vue';

export default {
  props: {
    value: {
      type: String,
      required: false,
      default: ''
    },

    readOnly: {
      type: Boolean,
      required: false,
      default: false
    },

    printView: {
      type: Boolean,
      required: false,
      default: true
    },

    valueState: {
      type: Number,
      required: false,
      default: -1
    }
  },

  data: () => ({
    commentText: '',
    autoSaveInterval: 30000,
    autoSaveTimer: null,
    fieldWidth: undefined
  }),

  computed: {
    hint() {
      if (this.valueState !== feedbackEnums.valueState.COPIED) {
        return '';
      }

      return this.$t('feedbacks.copiedValueInfo');
    }
  },

  watch: {
    commentText() {
      this.$emit('input', this.commentText);
    },

    value() {
      this.commentText = this.value;
    }
  },

  mounted() {
    this.commentText = this.value;
  },

  beforeDestroy() {
    if (this.autoSaveTimer) {
      window.clearTimeout(this.autoSaveTimer);
    }
  },

  methods: {
    enterField() {
      const vm = this;

      if (!this.readOnly && !this.printView) {
        vm.autoSaveTimer = window.setInterval(() => {
          vm.$emit('change');
        }, vm.autoSaveInterval);
      }
    },

    leaveField() {
      if (!this.readOnly && !this.printView) {
        this.$emit('change');
      }

      if (this.autoSaveTimer) {
        window.clearTimeout(this.autoSaveTimer);
      }
    }
  },

  components: {
    TipTap
  }
};
</script>
